<template lang="pug">
  .auth--confirm

    form.auth__form(
      v-if="!success && !fails && !failsNotExist"
      @submit.prevent="registerUser")
      input(
        type="text"
        name="name"
        v-model="name"
        v-validate="'required|max:35|min:2'"
        :data-vv-as="$t('auth.form.name')"
        :class="{'error': errors.has('name') }"
        :placeholder="$t('auth.form.name')"
        autofocus)

      input(
        type="text"
        name="lastName"
        v-model="lastName"
        v-validate="'required|max:35|min:2'"
        :data-vv-as="$t('auth.form.lastName')"
        :class="{'error': errors.has('lastName') }"
        :placeholder="$t('auth.form.lastName')")

      input(
        type="email"
        name="email"
        v-model="email"
        v-validate="'required|email'"
        :data-vv-as="$t('auth.form.email')"
        :class="{'error': errors.has('email') }"
        :placeholder="$t('auth.form.email')"
        disabled)

      Password(
          name="password"
          v-model="password"
          v-validate="'required|max:64|min:8'"
          :data-vv-as="$t('auth.form.password')"
          :error="errors.has('password')"
          :placeholder="$t('auth.form.password')")


      .margin-halve-top
        .auth__error(v-show="errors.has('name')") {{ errors.first('name') }}
        .auth__error(v-show="errors.has('lastName')") {{ errors.first('lastName') }}
        .auth__error(v-show="errors.has('email')") {{ errors.first('email') }}
        .auth__error(v-show="errors.has('password')") {{ errors.first('password') }}


      //- Terms of Use checkbox
      .margin-top {{ $t('auth.authorize') }}

      //- Commercial notification checkbox
      .checkbox.margin-quarter-top.padding-left
        input(
          type="checkbox"
          name="commercial"
          v-model="commercial")

        label(for="commercial")
          | {{ $t('auth.marketing') }}

      //- Commercial notification checkbox
      .checkbox.margin-quarter-top.padding-left(v-if="showSupportEmail")
        input(
          type="checkbox"
          name="support"
          v-model="support")

        label(for="support")
          | {{ $t('auth.support') }}

      hr.padding-top.padding-bottom

      .margin-halve-bottom {{ $t('auth.agree')}}
      ul.links
        li(v-if="certTerms")
          a.link(:href="certTerms" target="_blank") {{ $t('auth.terms') }}
        li(v-if="certLicense")
          a.link(:href="certLicense" target="_blank") {{ $t('auth.license') }}
        li(v-if="certPrivacy")
          a.link(:href="certPrivacy" target="_blank") {{ $t('auth.privacy') }}

      van-button(
        size="large"
        type="primary"
        native-type="submit") {{ $t('auth.form.send') }}


    //- Fails get email
    .text--center(v-if="failsNotExist")
      van-icon(name="error")
      h1 {{ $t('errors.userNotExist.title')}}
      p {{ $t('errors.userNotExist.message')}}

    //- Succes send email confirm
    .text--center(v-if="success")
      van-icon(name="succes")
      h1 {{ $t('messages.invitedUser.title')}}
      p {{ $t('messages.invitedUser.message')}}

    //- Fails send email confirm
    .text--center(v-if="fails")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}
</template>

<script>
import i18n from '@/locales/i18n';
import UserService from '@/services/user.service';
import { CONFIG, DOCS } from '@/app.config';
import OpenLinkMixin from '@/mixins/OpenLink.mixin';
import Password from '@/components/Password.vue';

export default {
  components: { Password },
  mixins: [OpenLinkMixin],
  data() {
    return {
      name: '',
      lastName: '',
      email: '',
      password: '',
      toc: true,
      support: true,
      commercial: true,
      success: false,
      fails: false,
      failsNotExist: false,
      passwordField: 'password',
      passwordIcon: 'hide',
      showSupportEmail: CONFIG.SHOW_SUPPORT_EMAIL,
      isLoading: false,
      language: i18n.locale,
    };
  },

  computed: {
    certPrivacy() {
      return DOCS.PRIVACY[this.language.toUpperCase()] || DOCS.PRIVACY.EN;
    },
    certLicense() {
      return DOCS.LEGAL[this.language.toUpperCase()] || DOCS.LEGAL.ES;
    },
    certTerms() {
      return DOCS.TERMS[this.language.toUpperCase()] || DOCS.TERMS.EN;
    },
  },

  methods: {
    registerUser() {
      // Compruebo si hay una petición en curso,
      // si la hay, no hago nada
      if (this.isLoading) return;

      this.clearMessages();

      this.$validator.validateAll().then(async result => {
        if (result) {
          this.isLoading = true;
          this.$toast.loading({
            duration: 0,
            mask: true,
            message: i18n.t('general.loading'),
          });

          const { token } = this.$route.params;

          const data = {
            email: this.email,
            password: this.password,
            lang: i18n.locale,
            data: {
              name: this.name,
              lastName: this.lastName,
              toc: this.toc,
              commercial: this.commercial,
              support: this.support,
            },
          };

          try {
            await UserService.confirmSignup(token, data);
            this.isLoading = false;
            this.$toast.clear();
            this.success = true;
            setTimeout(() => {
              this.$router.push({ name: 'home' });
            }, 5000);
          } catch (error) {
            this.isLoading = false;
            this.$toast.clear();
            this.fails = true;
          }
        }
      });
    },

    clearMessages() {
      this.success = false;
      this.fails = false;
      this.failsNotExist = false;
    },
  },

  async created() {
    this.isLoading = true;

    this.$toast.loading({
      duration: 0,
      mask: true,
      message: i18n.t('general.loading'),
    });

    const { token } = this.$route.params;

    try {
      const resp = await UserService.checkUserHash(token);
      this.$toast.clear();
      this.isLoading = false;
      this.email = resp.data.email;
    } catch (error) {
      this.$toast.clear();
      this.isLoading = false;
      const errorId = error.response && error.response.data ? error.response.data._id : null;

      switch (errorId) {
        case 'userNotExist':
          this.failsNotExist = true;
          break;
        default:
          this.fails = true;
      }
    }
  },
};
</script>
